
  import { mapState } from 'vuex'

  export default {
    data() { 
      return {
        activeSection: 0
      }
    },
    mounted() {
      window.addEventListener('scroll', this.scroll)
      window.addEventListener('hashchange', this.handleHashChange)

      // Scroll to section if hash is set
      if (window.location.hash) {
        this.$nextTick(() => {
          this.goTo(window.location.hash.replace('#',''))
        })
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.scroll)
      window.removeEventListener('hashchange', this.handleHashChange)
    },
    computed: {
      ...mapState(['menu','defaultMenu','headerHeight','order', 'channel']),
      categories() {
        let menu = this.defaultMenu
        if (this.menu) {
          menu = this.menu
        }
        // Filter out categories with no available items for handoff mode
        let categories = []
        menu.categories.forEach(category => {
          if (this.hasAvailableItems(category)) {
            categories.push(category)
          }
        })
        return categories
      },
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      }
    },
    methods: {
      handleHashChange() {
        if (window.location.hash) {
          this.goTo(window.location.hash.replace('#',''))
        }
      },
      getImage(category) {
        let image = ''
        category?.images?.forEach(type => {
          if (type.groupname == 'mobile-webapp-menu' && this.mobile) {
            image = type.filename
          }
          if (type.groupname == 'desktop-menu' && !this.mobile) {
            image = type.filename
          }
        })

        return process.env.GW_ENV === 'stage' ? 'https://olo-images.imgix.net/'+image : 'https://olo-images-live.imgix.net/'+image
      },
      scroll() {
        // Change nav style after scroll
        const nav = document.querySelector('.menu-nav .nav')
        const header = document.querySelector('header')
        const content = document.querySelector('.menu-nav').nextElementSibling
        const navHeight = this.mobile ? 48 : 65
        if (content.getBoundingClientRect().top >= navHeight) {
          nav.classList.remove('scrolled')
          nav.removeAttribute('style')
        } else {
          nav.classList.add('scrolled')
          nav.style.top = (header.clientHeight-4)+'px'
        }
        // Select active section on scroll
        let el
        let top
        let min = Number.MAX_VALUE
        const sections = document.querySelectorAll('[data-category]')
        for (let i = 0; i < sections.length; i++) {
          top = Math.abs(sections[i].getBoundingClientRect().top)
          if (top < min+120) {
            min = top
            if (this.activeSection !== i || this.activeSection == 0) {
              this.activeSection = i
              const nav = document.querySelector('.menu-nav .nav')
              const button = nav.querySelector('div.active')
              // Scroll nav to button
              if (this.activeSection == 0) {
                nav.scrollTo({
                  left: 0,
                  behavior: 'smooth'
                })
              } else {
                nav.scrollTo({
                  left: button.offsetLeft-16,
                  behavior: 'smooth'
                })
              }
            }
          }
        }
        // Near bottom of page, make last section active
        if (window.innerHeight + window.pageYOffset + 60 >= document.body.offsetHeight - 2) {
          this.activeSection = sections.length - 1
        }
      },
      slug(name) {
        return name.toLowerCase().replace(/ /g, '-').replace(/'/g, '').replace(/’/g, '').trim()
      },
      goTo(category) {
        this.$nextTick(() => {
          if (!this.headerHeight) {
            setTimeout(() => {
              this.goTo(category)
            },1000)
            return false
          }
          const section = document.querySelector('[data-category="'+this.slug(category)+'"]')
          if (section) {
            const navHeight = this.mobile ? 48 : 65
            let position = (section.offsetTop - parseInt(this.headerHeight.replace('px','')) - navHeight)
            // Scroll to top if first category is selected
            if (category == this.categories[0].name.split(' - ')[0]) {
              position = 0
            }
            window.scrollTo({ top: position, behavior: 'smooth' })
          }
        })
      },
      hasAvailableItems(category) {
        if (this.order && this.order.handoff) {
          let hasAvailableItems = false
          category.products.forEach((product) => {
            const unavailablehandoffmodes = product.unavailablehandoffmodes || []
            if (!unavailablehandoffmodes.includes(this.order.handoff)) {
              hasAvailableItems = true
            }
          })
          return hasAvailableItems
        } else {
          return true
        }
      }
    }
  }
